<template>
  <div class="questionEdit">
    <bread-crumb v-if="!isComponent"></bread-crumb>
    <div class="wrap">
      <!-- 分栏 -->
      <c-title v-if="!isComponent" title="基本内容" />
      <!-- 上传封面图组件 :required="false" -->
      <upload-image
        @change-title-pic="changeTitlePic"
        :required="false"
        :data="form.titlePicUrl"
      />
      <!-- sku信息 -->
      <div
        class="content-item flex align-items-center"
        v-if="contentSkus && contentSkus[0] && form.sourceType === 10"
      >
        <p class="content-item-label">sku</p>
        <div class="sku-container">
          <div class="sku-item" v-for="item in contentSkus" :key="item.skuId">
            <img class="sku-img" :src="getSkuIcon(item)" alt="" />
            <span class="sku-name" @click="onClickSku(item)">{{
              `${item.skuName}`
            }}</span>
          </div>
        </div>
      </div>
      <!-- 问题标题TEXT输入框 -->
      <div class="content-item flex align-items-center">
        <p class="content-item-label"><span class="red">*</span>问题标题</p>
        <el-input
          v-model="form.contentName"
          class="article_tit"
          show-word-limit
          maxlength="100"
          placeholder="请输入问题标题"
        ></el-input>
      </div>
      <!-- 提问人TEXT输入框 -->
      <div class="content-item flex align-items-center">
        <p class="content-item-label">提问人</p>
        <el-input
          v-model="form.authorName"
          class="article_tit"
          show-word-limit
          maxlength="100"
          placeholder="请输入提问人"
        ></el-input>
      </div>
      <!-- 想获得的帮助TEXT输入框 -->
      <div class="content-item flex align-items-center">
        <p class="content-item-label">想获得的帮助</p>
        <el-input
          v-model="form.helps"
          class="article_tit"
          show-word-limit
          maxlength="100"
          placeholder="请输入想获得的帮助"
        ></el-input>
      </div>
      <!-- 敏感词 -->
      <sensitive-words :sensitiveWords.sync="form.sensitiveWords" />
      <!-- 富文本编辑器 -->
      <div class="content-item flex">
        <p class="content-item-label">问题描述</p>
        <c-editor
          ref="editorRef"
          :content="form.content || ''"
          index="q1"
          @editorReady="editorReady"
          @blurEditorEvent="blurEditorEvent"
        />
      </div>
      <template v-if="!isComponent">
        <!-- 分栏 -->
        <c-title title="基本信息" class="mar-top-20" />
        <!-- 内容分发 -->
        <content-label-info
          :contentId="form.contentId"
          ref="contentLabelInfo"
          :sourceType="form.sourceType"
          :articleIndex="contentIndexes"
          :contentType="14"
          @indexChange="indexChange"
          @distribute-change="radioChange"
        >
        </content-label-info>
        <!-- 分栏 -->
        <c-title title="疾病库" class="mar-top-20" />
        <content-label-qa
          :data="form.contentRelations"
          @changeDiseaseLabels="changeDiseaseLabels"
          :is-show-disease="isShowDisease"
          :isQuestion="isQuestion"
          :functionIds="{ queryContents: 'health_cmp_pageDiseaseInfoByParam' }"
        >
        </content-label-qa>
        <!-- 症状库 -->
        <c-title title="症状库" class="mar-top-20" />
        <symptom-label
          :csdata="form.contentSymptoms"
          @changeSymptomLabels="changeSymptomLabels"
          :functionIds="{ getSymptom: 'health_cmp_pageSymptomByName' }"
        />
        <!-- 分栏 -->
        <c-title title="标签信息" class="mar-top-20" />
      </template>
      <div class="content-item flex align-items-center" v-show="!isComponent">
        <question-cascader
          :id="form.contentId"
          v-show="!isComponent"
          ref="questionLabel"
        ></question-cascader>
      </div>
      <!-- 类目标签 -->
      <category-label
        v-if="!isComponent"
        :data="form.categorys"
        @changeCategoryLabels="changeCategoryLabels"
        :functionIds="{ getCategorys: 'health_cmp_queryCategoryByIds' }"
      />
      <!-- 商品标签 -->
      <content-skus-label
        v-if="form.sourceType !== 10 && !isComponent"
        :data="form.contentSkus"
        @changeContentSkusLabels="changeContentSkusLabels"
        :functionIds="{ getContentSkus: 'health_cmp_biz_querySkus' }"
      />
      <!-- 业务栏目渠道 -->
      <business-question
        v-show="!isComponent"
        :contentId="form.contentId"
        ref="businessQA"
        v-if="this.distribute"
      ></business-question>
      <!--      按钮-->
      <template v-if="!isComponent">
        <div class="finish-btns">
          <el-button type="primary" v-if="auditInfoShow == 2" @click="adopt(1)"
            >通过</el-button
          >
          <el-button v-if="auditInfoShow !== 2" @click="adopt(2)"
            >提交</el-button
          >
          <el-button v-if="auditInfoShow == 2" @click="rejectClick"
            >驳回</el-button
          >
          <el-button @click="adopt(3)">预览</el-button>
        </div>
      </template>
    </div>
    <!-- 预览弹窗 -->
    <preview-modal
      v-if="!isComponent"
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    />
    <!--驳回弹窗-->
    <reject-modal
      :rejectForm.sync="rejectForm"
      @rejectClickHandler="rejectClickHandler"
    ></reject-modal>
  </div>
</template>

<script>
import BreadCrumb from "@/components/breadCrumb";
import CTitle from "@/components/customize/CTitle";
import uploadImage from "@/components/upload/uploadImage";
import QuestionCascader from "@/components/select/QuestionCascader";
import BusinessQuestion from "@/components/tag/BusinessQuestion";
import CEditor from "@/components/editor/CEditor";
import RejectModal from "@/components/pop/RejectModal";
import ContentLabelQa from "@/components/tag/ContentLabelQa";
import PreviewModal from "@/components/pop/PreviewModal";
import CategoryLabel from "@/components/combination/CategoryLabel";
import ContentSkusLabel from "@/components/combination/ContentSkusLabel";
import SensitiveWords from "@/components/input/SensitiveWords";
import ContentLabelInfo from "@/components/tag/contentLabelInfo";
import SymptomLabel from "@/components/combination/SymptomLabel";
import {
  queryQAById,
  queryListParagraph,
  submitQuestion,
  rejectQuestion,
  adoptQuestion,
  modifyQuestion,
} from "@/api/questionsLibrary";
import { getQRCode } from "@/utils/tools";

import utils from "@/utils";
const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  name: "questionEdit",
  props: ["isComponent", "formData"],
  components: {
    BreadCrumb,
    CTitle,
    uploadImage,
    QuestionCascader,
    BusinessQuestion,
    CEditor,
    RejectModal,
    ContentLabelQa,
    CategoryLabel,
    ContentSkusLabel,
    PreviewModal,
    SensitiveWords,
    ContentLabelInfo,
    SymptomLabel,
  },
  data() {
    return {
      res: {},
      baseUrl,
      contentType: 14, // 14-问题
      openFlag: true, // 是否对外推广
      contentAttribute: [], // 内容分发楼层信息
      isShowDisease: false,
      isQuestion: true,
      paragraphList: [], // 段落
      editorList: {},
      statusInfo: "", // 传后台的数据
      auditInfoShow: "", // 判断问题状态，底部显示不同按钮
      contentSkus: {}, // 问答绑定的contentSkus
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      form: {
        contentId: undefined, // 内容基本信息id
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        contentRelations: [], // 关联的其他内容 仅需要id和type
        categorys: [], // 关联的其他内容 仅需要id和type
        titlePicUrl: "", // 封面图片信息
        contentStatus: null, // 内容状态 1 上线 2下线
        auditInfo: {
          auditStatus: "",
          auditTime: "",
          auditUser: "",
          remark: "",
        }, // 审核信息
        contentLabels: [], // 标签信息
        contentParagraphs: [], // 段落信息汇总
        content: "", // 段落信息
        helps: "", // 想要获得的帮助
        contentUsers: [], // 内容关联的用户
        keywordInfos: [], // 内容关键词
        bodyParts: [], // 身体部位
        contentAuditStatus: 1, // 内容审核状态1草稿、2待审核、3审核通过、4驳回
        departments: [], // 科室信息
        contentSymptoms: [], //绑定疾病id
        extensionContentLabels: [],
        contentChannels: [],
        contentCategorys: [],
        contentBusinesses: [],
        authorName: "", // 提问人信息
        sensitiveWords: "",
        contentIndexes: [], // 索引
      },
      authorPin: "",
      contentIndexes: [],
      distribute: undefined, // 控制推广展示
      // 预览弹框是否显示
      dialogPreVisible: false,
      // 预览弹框二维码
      qrCode: "",
      // 预览弹框文章链接
      mUrl: "",
      titlePicUrl: "", // 封面图
      //
      contentDiags: [],
      contentRiskControls: [],
      contentAttachments: [],
    };
  },
  async created() {
    if (this.$route.query.id && !this.isComponent) {
      this.form.contentId = this.$route.query.id;
      await this.getDiseaseInfoDraftDetail();
      // this.getContentAttribute();
      this.getParagraph();
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(".el-cascader-node[aria-owns]");
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    }, 300);
  },
  watch: {
    formData(newVal) {
      // this.form = (newVal);
      if (this.isComponent) {
        this.statusInfo = newVal.statusInfo;
        this.contentDiags = newVal.contentDiags || [];
        this.contentRiskControls = newVal.contentRiskControls || [];
        this.contentAttachments = newVal.contentAttachments || [];
        this.form.contentId = this.formData.contentId;
        this.displayInfo(newVal);
        this.$refs.questionLabel.getTagGroup(this.formData.contentId);
        this.$refs.businessQA?.getBusiness(this.formData.contentId);
      }
    },
  },
  methods: {
    // 格式化传递给后端的 症状库 数据，因为后端不能传symptomName; type 1 添加str， 2 去掉str
    formatSymptomData(data, type) {
      const arr = [];
      data.forEach((item) => {
        console.log(
          "🚀 ~ file: index.vue:230 ~ data.forEach ~ item:",
          item,
          type
        );
        const tmpObj = {};
        tmpObj.symptomId = item.symptomId;
        if (type === 1) {
          tmpObj.symptomNameStr = item.symptomName;
        } else {
          tmpObj.symptomName = item.symptomNameStr;
        }
        arr.push(tmpObj);
      });
      console.log("🚀 ~ file: index.vue:374 ~ formatSymptomData ~ arr:", arr);
      return arr;
    },
    // 症状
    changeSymptomLabels(data) {
      this.form.contentSymptoms = data;
    },
    // 内容分发切换
    radioChange(event) {
      this.distribute = event;
    },
    changeTitlePic(data) {
      // data-封面组件的返回值
      this.titlePicUrl = data;
      if (this.titlePicUrl && this.titlePicUrl.length > 0) {
        let url = this.titlePicUrl[0].url;
        // url 要截去的那部分 这个要从环境变量中取
        const imgHost = process.env.VUE_APP_imgHost;
        this.form.titlePicUrl = url.replace(imgHost, "");
      } else {
        this.form.titlePicUrl = "";
      }
    },
    cancel: function () {
      this.$router.push(`/questionAnswer/questionList`);
      this.hopStorage();
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem("questionState", 1);
    },
    // 内容索引赋值
    indexChange(val) {
      this.contentIndexes = val;
    },
    // 通过、提交
    adopt(type, callback) {
      this.initFormBeforeAddOrUpdate();
      // 内容校验
      if (!this.checkBeforeAddOrUpdate()) {
        return;
      }
      // 图片检验
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      // 处理提交的 form 数据
      let params = {
        contentType: this.contentType,
        tenantId: this.$commonJs.getTenantId(),
        auditInfo: this.form.auditInfo,
        contentId: this.form.contentId,
        statusInfo: this.statusInfo,
        contentName: this.form.contentName,
        titlePicUrl: this.form.titlePicUrl,
        contentLabels: this.form.extensionContentLabels,
        contentParagraphs: this.form.contentParagraphs,
        contentCategorys: this.form.contentCategorys,
        contentDiseases: this.form.contentRelations,
        categorys: this.form.categorys,
        contentSkus:
          this.form.sourceType === 10
            ? this.contentSkus
            : this.form.contentSkus, // 问答绑定的sku信息或商品sku
        contentAttributes: this.$refs.contentLabelInfo?.dataProcessing() || [],
        authors:
          this.form.authorName != ""
            ? [
                {
                  authorName: this.form.authorName,
                  authorType: 4,
                  pin: this.authorPin,
                },
              ]
            : [],
        contentDiags: this.contentDiags || [],
        contentRiskControls: this.contentRiskControls || [],
        contentAttachments: this.contentAttachments || [],
        contentIndexes: this.form.contentIndexes, // 索引字段
        contentSymptoms: this.formatSymptomData(this.form.contentSymptoms, 1),
      };
      modifyQuestion(params)
        .then((res) => {
          if (this.isComponent) {
            callback();
            return;
          }
          if (type == 1) {
            let adoptParams = {
              tenantId: Number(this.$commonJs.getTenantId()),
              contentId: this.form.contentId,
            };
            adoptQuestion(adoptParams)
              .then((res) => {
                if (res) {
                  this.$router.push(`/questionAnswer/questionList`);
                  this.$message.success("通过成功");
                  this.hopStorage();
                }
              })
              .catch((err) => {
                this.$message.error(err.msg + "通过失败");
              });
          } else if (type == 2) {
            submitQuestion(params)
              .then((res) => {
                if (res) {
                  this.$router.push(`/questionAnswer/questionList`);
                  this.$message.success("提交成功");
                  this.hopStorage();
                }
              })
              .catch((err) => {
                this.$message.error(err.msg + "提交失败");
              });
          } else if (type == 3) {
            // 预览
            this.articlePreview(this.form.contentId);
          }
        })
        .catch((err) => {
          console.log("修改问题失败");
          console.log(err);
          this.$message.error(err.msg + "，修改保存失败");
        });
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl(val);
    },
    jumpUrl(urlId) {
      const urlAddress = "//beta-api.m.jd.com";
      const url = `https://laputa${
        this.baseUrl == urlAddress ? "-yf" : ""
      }.healthjd.com/content/article/qadetail?id=${urlId}`;
      this.mUrl = url;
      getQRCode(url, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    // 驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          rejectQuestion({
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              this.$router.push(`/questionAnswer/questionList`);
            })
            .catch((err) => {
              this.$message.error(err.msg || "驳回失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
    },
    editorReady(data) {
      this.form.content = data.editor.getContent();
      this.restoreContentParagraphs(data);
    },
    // 处理数据
    initFormBeforeAddOrUpdate() {
      // 组件嵌入时不用传
      this.$refs.questionLabel.getFormLabelData(this.form);
      // 内容分发
      if (this.distribute) {
        this.$refs.businessQA.getBizListData(this.form);
      }
      // 索引
      if (this.contentIndexes.length > 0) {
        this.form.contentIndexes = [
          { indexId: this.contentIndexes[this.contentIndexes.length - 1] },
        ];
      }
      this.form.contentParagraphs = [];
      // 将帮助加入到contentParagraphs 中
      if (this.form.helps.trim() != "") {
        let obj = {
          paragraphCode: "2",
          paragraphName: "想要获得的帮互助",
          paragraphContent: this.form.helps,
          paragraphType: 10,
        };
        this.form.contentParagraphs.push(obj);
      }
      if (this.form.content.trim() != "") {
        let obj = {
          paragraphCode: "1",
          paragraphName: "问题描述",
          paragraphContent: this.form.content,
          paragraphType: 10,
        };
        this.form.contentParagraphs.push(obj);
      }
    },
    // 校验
    checkBeforeAddOrUpdate() {
      if (this.form.contentName.trim() == "") {
        this.$message.error("标题不能为空");
        return false;
      }
      // 若为组件引用，以下都不校验
      if (this.isComponent) {
        return true;
      }
      if (this.distribute == undefined) {
        this.$message.error("请选择内容分发信息");
        return false;
      }
      // 索引选择必选, 若为sourceType 主站问答为10 不必选
      if (
        this.form.contentIndexes.length === 0 &&
        this.form.sourceType !== 10 &&
        this.form.sourceType !== 11
      ) {
        this.$message.error("请选择内容索引");
        return false;
      }
      return true;
    },
    // 获取文章详情
    async getDiseaseInfoDraftDetail() {
      await queryQAById({
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.res = res;
        this.statusInfo = res.statusInfo;
        this.contentDiags = res.contentDiags || [];
        this.contentRiskControls = res.contentRiskControls || [];
        this.contentAttachments = res.contentAttachments || [];
        this.displayInfo(res);
      });
    },
    // 反显
    displayInfo(res) {
      // 返显
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      // 把问题的审核状态  作为入参
      const { auditStatus, auditTime, auditUser, remark } = res.auditInfo;
      if (this.form.auditInfo) {
        this.form.auditInfo.auditStatus = auditStatus;
        this.form.auditInfo.auditTime = auditTime;
        this.form.auditInfo.auditUser = auditUser;
        this.form.auditInfo.remark = remark;
      }
      // 症状反显
      if (res.contentSymptoms) {
        this.form.contentSymptoms = this.formatSymptomData(
          res.contentSymptoms,
          2
        );
      }
      // 索引反显
      const treeToArrObj = (obj) => {
        console.log(obj);
        if (!obj.contentIndexes || obj.contentIndexes.length === 0) {
          console.log({ indexId: obj.indexId });
          return { indexId: obj.indexId };
        }
        treeToArrObj(obj.contentIndexes[0]);
      };
      const treeToArr = (obj, arr) => {
        if (obj && obj.indexId) {
          arr.push(obj.indexId);
          treeToArr(obj.contentIndexes[0], arr);
        }
        if (!obj || !obj.contentIndexes || obj.contentIndexes.length === 0) {
          return arr;
        }
      };
      if (res?.contentIndexes?.length > 0) {
        const arr = [];
        treeToArr(res.contentIndexes[0], arr);
        this.form.contentIndexes = [treeToArrObj(res.contentIndexes[0])];
        console.log(
          arr,
          this.form.contentIndexes,
          treeToArrObj(res.contentIndexes[0])
        );
        this.contentIndexes = arr;
      }
      const { contentName, contentParagraphs, contentRiskControls } = res;
      this.form.contentParagraphs = contentParagraphs || [];

      // 把段落部分的帮助和内容部分 拆分开
      if (contentParagraphs) {
        contentParagraphs.forEach((item) => {
          if (item.paragraphCode == 1) {
            this.form.content = item.paragraphContent;
          } else if (item.paragraphCode == 2) {
            this.form.helps = item.paragraphContent;
          }
        });
      }
      let arr = [];
      contentRiskControls &&
        contentRiskControls.length > 0 &&
        contentRiskControls.map((val) => {
          arr.push(val.sensitiveWord);
        });
      const sensitiveWordsStr = arr.length > 0 ? arr.join(",") : "";
      this.form.sensitiveWords = sensitiveWordsStr;
      this.form.contentName = contentName;
      this.form.titlePicUrl = res.titlePicUrl;
      this.form.contentRelations = res.contentDiseases;
      this.form.categorys = res.categorys ? res.categorys : [];
      this.form.contentSkus = res.contentSkus || [];
      // 获取提问人名字
      if (res.authors && res.authors.length > 0) {
        res.authors.forEach((item) => {
          if (item.authorType == 4) {
            this.form.authorName = item.authorName;
            this.authorPin = item.pin || "";
          }
        });
      }
      this.contentSkus = res.contentSkus || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      // 判断段落内容 里面是否有值
      var isFirstAdd = this.paragraphList.length == 0;
      // 把文章详情的值给  this.paragraphList
      res.contentParagraphs &&
        res.contentParagraphs.map((item, index) => {
          if (isFirstAdd) {
            this.paragraphList.push({
              code: item.paragraphCode,
              desc: item.paragraphName,
              type: item.paragraphType,
              content: item.paragraphContent || "",
            });
          } else {
            for (var i = 0; i < this.paragraphList.length; i++) {
              if (this.paragraphList[i].code == item.paragraphCode) {
                this.paragraphList[i].content == item.paragraphContent || "";
                break;
              }
            }
          }
          try {
            var isEditorInited = setInterval(() => {
              var edd = this.editorList["editor" + (index + 1)];
              if (edd) {
                clearInterval(isEditorInited);
                edd.setContent(item.paragraphContent || "");
              }
            }, 100);
          } catch (error) {
            console.log(error);
          }
        });
      if (res.sourceType) {
        this.form.sourceType = res.sourceType;
      }
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    changeCategoryLabels(data) {
      // 拿到类目标签
      this.form.categorys = data;
    },
    changeContentSkusLabels(data) {
      // 拿到商品标签
      this.form.contentSkus = data;
    },
    // 获取段落
    getParagraph() {
      queryListParagraph({
        tenantId: this.$commonJs.getTenantId(),
        type: 10,
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取文本编译器内的内容  并文章缓存处理  目前缓存有问题  刷新页面但不点击保存的时候 无法保留复现 后续可按需求考虑是否优化
    blurEditorEvent(editor, index) {
      // 获取编译器中的文本
      this.form.content = editor.getContent();

      if (this.paragraphList.length > 0) {
        this.paragraphList[index].content = editor.getContent() || "";
      }

      // eslint-disable-next-line no-undef
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // // eslint-disable-next-line no-undef
      // let ParentElement = $(editor.editorContainer)
      //   .find(".tox-toolbar__group")
      //   .eq(0);
      // let subelement = ParentElement.find(".successfully");
      // // 只创建一次
      // if (subelement.length == 0) {
      //   // eslint-disable-next-line no-undef
      //   $(editor.editorContainer)
      //     .find(".tox-toolbar__group")
      //     .eq(0)
      //     .append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function() {
      //   // eslint-disable-next-line no-undef
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove();
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      // 暂时注释
      // this.form.contentParagraphs[index].paragraphContent = editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },

    getSkuIcon(item) {
      return "//image.healthjd.com/da/" + item.imgDfsUrl;
    },
    onClickSku(item) {
      window.open(`https://item.jd.com/${item.skuId}.html`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";
@import "@/styles/article_common.scss";

.questionEdit {
  @include article_common;
  // 弹窗提示的body样式
  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }
  // 表单Item样式
  .wrap .content-item .content-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  :deep(.content-item p) {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .sku-container {
    padding: 4px;
    background: #f7f7f7;
    border-radius: 4px;

    .sku-item {
      display: flex;
      align-items: center;

      .sku-img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
      }
      .sku-name {
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}

.finish-btns {
  position: fixed;
  text-align: center;
  width: 85%;
  background-color: #ffffff;
  bottom: 0;
}
</style>
